import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';
import { formatImportCount } from '@feathr/extender/components/ImportRunLines';

import { getFullyImportedRowCount } from './ImportRunDetails.utils';

interface IImportedRowsLineProps {
  importer: Importer;
}

/** "1,240 rows successfully imported." for a complete import that skipped no rows. */
function ImportedRowsLine({ importer }: Readonly<IImportedRowsLineProps>): JSX.Element | null {
  const { t } = useTranslation();

  const count = getFullyImportedRowCount(importer);
  if (count === undefined) {
    return null;
  }

  // Placeholder copy, pending Product and Design (decision 23).
  return (
    <Text.DefaultRegular>
      {t('{{formattedCount}} rows successfully imported.', {
        count,
        formattedCount: formatImportCount(count),
      })}
    </Text.DefaultRegular>
  );
}

export default observer(ImportedRowsLine);
